<template>
  <div v-if="showStandalonePopup && deviceInfo.type">
    <div
      class="standalone-popup__backdrop"
      @click="onBackdropClick"
    ></div>
    <div
      class="standalone-popup"
    >
      <button
        class="standalone-popup__close"
        type="button"
        @click="onCloseClick"
      ><Icon identifier="close" /></button>

      <h2>
        Voeg Kwispelcoach toe aan je homescherm
      </h2>

      <div v-if="deviceInfo.type === 'ios' && deviceInfo.browser === 'safari'">
        <ol>
          <li>Klik op het deel icoontje (vierkant met pijl omhoog).</li>
          <li>Scroll naar beneden en klik op 'Zet in beginscherm'</li>
          <li>Pas eventueel de naam aan en klik op 'Toevoegen'</li>
        </ol>
      </div>

      <div v-if="deviceInfo.type === 'ios' && deviceInfo.browser === 'chrome'">
        <ol>
          <li>Klik op het deel icoontje (rechts van de adresbalk).</li>
          <li>Scroll naar beneden en klik op 'Toevoegen aan beginscherm'</li>
          <li>Pas eventueel de naam aan en klik op 'Toevoegen'</li>
        </ol>
      </div>

      <div v-if="deviceInfo.type === 'ios' && deviceInfo.browser === 'firefox'">
        <ol>
          <li>Klik op het deel icoontje in de adresbalk.</li>
          <li>Scroll naar beneden en klik op 'Zet in beginscherm'</li>
          <li>Pas eventueel de naam aan en klik op 'Toevoegen'</li>
        </ol>
      </div>

      <div v-if="deviceInfo.type === 'android' && deviceInfo.browser === 'chrome'">
        <ol>
          <li>Klik rechtsbovenin op de drie puntjes.</li>
          <li>Klik op 'Toevoegen aan startscherm'</li>
          <li>Klik op 'Toevoegen'</li>
        </ol>
      </div>

      <div v-if="deviceInfo.type === 'android' && deviceInfo.browser === 'firefox'">
        <ol>
          <li>Klik op het menu icoontje.</li>
          <li>Klik op 'Toevoegen aan startscherm'</li>
          <li>Pas eventueel de naam aan en klik op 'Toevoegen'</li>
        </ol>
      </div>

      <div v-if="deviceInfo.type === 'android' && deviceInfo.browser === 'samsung'">
        <ol>
          <li>Klik rechtsonderaan op het hamburger menu icoontje.</li>
          <li>Klik op 'Pagina toevoegen aan'</li>
          <li>Kies 'Startscherm'</li>
          <li>Klik op 'Toevoegen'</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import browserMode from '../helpers/browserMode';
import Icon from './Icon.vue';

export default {
  components: {
    Icon,
  },

  data() {
    return {
      showStandalonePopup: false,
      deviceInfo: {
        type: null,
        browser: null,
      },
    };
  },

  mounted() {
    this.detectDevice();
    this.checkPopupVisibility();

    // Forced to show popup for testing
    // this.showStandalonePopup = true;

    // Make sure we have a device type for testing
    if (!this.deviceInfo.type) {
      this.deviceInfo.type = 'ios';
      this.deviceInfo.browser = 'chrome';
    }
  },

  methods: {
    detectDevice() {
      const ua = window.navigator.userAgent;
      const platform = window.navigator.platform || '';

      // Check for URL parameters for testing
      if (this.isTestMode()) {
        return;
      }

      // iOS detection (more comprehensive)
      if (/iPad|iPhone|iPod/.test(ua) || (platform === 'MacIntel' && navigator.maxTouchPoints > 1 && !ua.includes('Chrome'))) {
        this.deviceInfo.type = 'ios';
        if (ua.includes('CriOS')) {
          this.deviceInfo.browser = 'chrome';
        } else if (ua.includes('FxiOS')) {
          this.deviceInfo.browser = 'firefox';
        } else {
          this.deviceInfo.browser = 'safari';
        }
      } else if (/Android/.test(ua)) {
        this.deviceInfo.type = 'android';
        if (ua.includes('SamsungBrowser')) {
          this.deviceInfo.browser = 'samsung';
        } else if (ua.includes('Firefox')) {
          this.deviceInfo.browser = 'firefox';
        } else if (ua.includes('Chrome')) {
          this.deviceInfo.browser = 'chrome';
        } else {
          this.deviceInfo.browser = 'other';
        }
      }
      // Could add Windows/MacOS detection if needed
    },

    isTestMode() {
      // Allow testing via URL parameters ?device=ios&browser=chrome
      const urlParams = new URLSearchParams(window.location.search);
      const deviceParam = urlParams.get('device');
      const browserParam = urlParams.get('browser');

      if (deviceParam) {
        this.deviceInfo.type = deviceParam;
        this.deviceInfo.browser = browserParam || 'chrome';
        this.showStandalonePopup = true;
        return true;
      }

      return false;
    },

    checkPopupVisibility() {
      if (browserMode() !== 'standalone' && window.localStorage && this.deviceInfo.type) {
        const localStorageValue = window.localStorage.getItem('standalone-popup');

        if (!localStorageValue) {
          this.showStandalonePopup = true;
          return;
        }

        const timestamp = parseInt(localStorageValue, 10);

        if (Number.isNaN(timestamp)) {
          this.showStandalonePopup = true;
          return;
        }

        const timeDifference = (new Date()).getTime() - timestamp;
        const timeDifferenceInHours = timeDifference / 1000 / 60 / 60;

        // If not shown for a week...
        if (timeDifferenceInHours >= 168) {
          this.showStandalonePopup = true;
        }
      }
    },

    onBackdropClick() {
      this.markPopupShown();
    },

    onCloseClick() {
      this.markPopupShown();
    },

    markPopupShown() {
      this.showStandalonePopup = false;

      window.localStorage.setItem('standalone-popup', (new Date()).getTime());
    },
  },
};
</script>

<style>
.standalone-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: calc(100% - 2rem);
  max-height: calc(100% - 2rem);
  background-color: #fff;
  border-radius: 1rem;
  z-index: 3;
  padding: 1rem;
  width: 100%;
}

.standalone-popup__backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(10, 10, 10, .5);
  z-index: 2;
}

.standalone-popup__close {
  position: absolute;
  top: -.5rem;
  right: -.5rem;
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid #ddd;
  padding: 0;
  background-color: #fff;
  border-radius: 50%;
  -webkit-appearance: none;
}

.standalone-popup__close svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: .8rem;
  height: .8rem;
}

.standalone-popup ol {
  counter-reset: list;
}

.standalone-popup ol li {
  counter-increment: list;
  position: relative;
  padding-left: 2rem;
  margin-bottom: .5rem;
}

.standalone-popup ol li:before {
  content: counter(list);
  width: 1.5rem;
  height: 1.5rem;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--purple);
  color: #fff;
  border-radius: 50%;
  text-align: center;
}

@media (min-width: 480px) {
  .standalone-popup {
    width: 400px;
    padding: 2rem;
  }
}
</style>
